
import { get, del, post, postFd, put, download } from "@utils/axios";

export const countNavNotificationsReq = (navkey) => {
  return get(`nav/count_by_key?nav_key=${navkey}`)
};
export const getRolePermissionsReq = (roleId) => {
  return get(`role/${roleId}/get-permissions`)
};
